import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpErrorResponse
} from '@angular/common/http';
import { Router } from '@angular/router';
import { JwtService } from '@ecosure-suite/shared/util-auth';
import { LogService } from '@ecosure-suite/shared/util-logging';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { NotificationsService } from '@ecosure-suite/shared/utils-notifications';

@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptorService implements HttpInterceptor {
  constructor(
    private jwtService: JwtService,
    private logService: LogService,
    private router: Router,
    private notification: NotificationsService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return next.handle(req).pipe(
      catchError((response: any) => {
        if(response instanceof HttpErrorResponse){
          if(response.status === 500 && response.url.includes('claims'))
            this.notification.showError('Error', response.error)
          if(response.error.error == 'invalid_grant')
             localStorage.setItem('err', response.error.error_description);
          if(response.error.error_description == 'Invalid refresh token'){
            localStorage.setItem('err', response.error.error_description);
            setTimeout(()=> window.location.reload(), 500);
          }
        }
        if (response instanceof HttpErrorResponse && response.status === 401) {
          this.jwtService.destroyToken();
          this.router.navigateByUrl('/login');
        }
        return throwError(response);
      })
    );
  }
}
